/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../Components/Core/Layout';
import SEO from '../Components/Core/Seo';
import PageBuilder from '../Components/Core/PageBuilder';
import { BlogCards } from '../Components/Custom/Card-Sections/BlogCards';
import OptimumStoresBanner from '../Components/Custom/Optimum/OptimumStoresBanner';
import LegalDetails from '../Components/Custom/LegalDetails';
import BackToTop from '../Components/Core/BackToTop';
import HeroCarousel from '../Components/Custom/Sections/HeroCarousel';
import StaticSplitWidthHeroBanner from '../Components/Custom/Banners/StaticSplitWidth';
import DigitalProductBanner from '../Components/Custom/DigitalProduct/DigitalProductBanner';
import { SpecialOffersBanner } from '../Components/Custom/AppBanner';
import SimpleImageBanner from '../Components/Custom/Banners/SimpleImageBanner';
import StatementSection from '../Components/Custom/StatementSection';
import { ProductImageCards } from '../Components/Custom/Card-Sections/ProductImageCards';
import { RatingAndTestimonialSection } from '../Components/Custom/Sections';

const pageTemplate = {
  'hero-carousel': HeroCarousel,
  'pcma-hero': StaticSplitWidthHeroBanner,
  'static-split-width-content': StaticSplitWidthHeroBanner,
  'statement-section': StatementSection,
  'simple-image-banner': SimpleImageBanner,
  'special-offers': SpecialOffersBanner,
  'digital-app-banner': DigitalProductBanner,
  'pc-optimum-store-banner': OptimumStoresBanner,
  'product-image-section': ProductImageCards,
  'testimonial-rating-section': RatingAndTestimonialSection,
  'blog-section': BlogCards,
  'legal-details': LegalDetails,
};

const IndexPage = ({
  location,
  data: {
    contentfulPageLayout: {
      languageToggle,
      promoCode,
      redirectPromoCode,
      topNotificationBanner,
      customHeader,
      sections,
      customFooter,
      internal: { type },
    },
  },
}) => {
  return (
    <Layout
      location={location}
      header={customHeader}
      footer={customFooter}
      languageToggle={languageToggle}
      promoCode={promoCode}
      redirectPromoCode={redirectPromoCode}
      banner={topNotificationBanner}
      contentType={type}
    >
      <PageBuilder sections={sections} template={pageTemplate} />
      <BackToTop />
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
};

export const query = graphql`
  query HomePage($locale: String = "en-CA") {
    contentfulPageLayout(
      contentful_id: { eq: "3YhxkOncWGhkK3YryGOVdd" }
      node_locale: { eq: $locale }
    ) {
      node_locale
      pageTitle
      metaDescription
      languageToggle
      displayInSiteMap
      promoCode
      internal {
        type
      }
      redirectPromoCode {
        redirectedPromoCode
        redirectedUrl
      }
      ...global_header
      ...notification_banners
      sections {
        ...hero_banner
        ...statement_section
        ...simple_image_banner
        ...app_banner
        ...titleOrImageWithIconLists
        ...ticker_section
        ...blog_articles
        ...optimum_stores_banner
        ...legal_details
        ...section_container
        ...video_item
      }
      ...global_footer
    }
  }
`;

export default IndexPage;

export const Head = ({ location, data, pageContext }) => {
  const socialMediaLinks =
    data.contentfulPageLayout.customFooter.socialMediaIcons.map(
      social => social.link,
    );

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'PC Financial',
    alternateName: 'PCF',
    url: 'https://www.pcfinancial.ca',
    logo: `https://www.pcfinancial.ca${data.contentfulPageLayout.customHeader.brandLogoDam.asset.localImage.publicURL}`,
    sameAs: socialMediaLinks,
  };
  return (
    <SEO
      data={data.contentfulPageLayout}
      pageContext={pageContext}
      location={location}
    >
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </SEO>
  );
};
